// Vendor imports
const { Route } = require('react-router-dom')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AppHeader = require('client-v2/common/containers/app-header/component-smart')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const ArticleProfileModal = require('client-v2/common/containers/article-profile/components/modal-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
const CollectionSelectModal = require('client-v2/common/containers/collection-select-modal/component-smart')
const ConfirmModal = require('client-v2/common/containers/confirm-modal/component-smart')
const FeedAwareAppFooter = require('client-v2/common/containers/feed/app-footer').default
const OpenInAppButton = require('client-v2/common/containers/open-in-app-button/component-smart')
const ShareModal = require('client-v2/common/containers/share-modal/component-smart')
const Toasts = require('client-v2/common/containers/toasts/component-smart')
const LightweightEngagementTutorialModal = require('client-v2/common/containers/lightweight-engagement/containers/tutorial/modal-smart')
// Entry imports
const UserProfileContentHeader = require('../containers/content-header/component-smart')
const UserProfileContentNav = require('../containers/content-nav/component-smart')
const UserProfileFeed = require('../containers/feed/component-smart')
const UserProfileSocialHeader = require('../containers/social-header/component-smart')
const UserProfileSocialNav = require('../containers/social-nav/component-smart')

const bem = BemEntity('UserProfileLayout')

function UserProfileLayout() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('page')
      },
        tag(AppHeader, {
          className: bem.element('header')
        }),
        tag('div', {
          className: bem.element('body')
        },
          // Content page
          tag(Route, {
            component: UserProfileContentPage,
            exact: true,
            path: [
              '/:username',
              '/:username/collections',
              '/:username/collections/created',
              '/:username/collections/subscribed',
              '/:username/mixes',
              '/:username/posts'
            ]
          }),

          // Social page
          tag(Route, {
            component: UserProfileSocialPage,
            exact: true,
            path: [
              '/:username/followers',
              '/:username/following',
              '/:username/friends'
            ]
          })
        ),
        tag(FeedAwareAppFooter),
        tag(AppNav, {
          className: 'AppNav--mobile'
        })
      ),
      Portal.toModalRoot(
        tag(ArticleProfileModal),
        tag(CollectionSelectModal),
        tag(OpenInAppButton),
        tag(AuthModal),
        tag(ShareModal),
        tag(ConfirmModal),
        tag(Toasts),
        tag(LightweightEngagementTutorialModal)
      )
    )
  )
}

const wrappedComponent = withCommonRoot(UserProfileLayout)
module.exports = Object.assign(wrappedComponent, {
  // Export unwrapped component for testing purposes
  UserProfileLayout
})


// Internal components

function UserProfileContentPage() {
  return tag([
    tag(UserProfileContentHeader),
    tag(UserProfileContentNav),
    tag(UserProfileFeed)
  ])
}

function UserProfileSocialPage() {
  return tag([
    tag(UserProfileSocialHeader),
    tag(UserProfileSocialNav),
    tag(UserProfileFeed)
  ])
}
